export default "__VITE_ASSET__DZoE6vcO__"